import {Component, Input, OnInit} from '@angular/core';
import {UUID} from '@util/types';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {BusinessInitiationStatus, FeedbackListung, MyBusinessRelationResult, ordBIStatus} from '@services/resource/business-initiation-resource';
import {switchMap, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {VoilaUserService} from '@services/voila-user.service';
import {BusinessInitiationService} from '@services/business-initiation.service';
import {leq} from 'fp-ts/lib/Ord';
import {CommonModule} from '@angular/common';
import {MarkantElementsModule} from '@markant/elements-angular';
import {BusinessStatusTranslate} from '@util/pipes/business-status-translate';

@Component({
  selector: 'app-ampel',
  templateUrl: './ampel.component.html',
  styleUrls: ['./ampel.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MarkantElementsModule, BusinessStatusTranslate],
})
export class AmpelComponent implements OnInit {
  BusinessInitiationStatus = BusinessInitiationStatus;

  @Input() startupId: UUID;

  form: UntypedFormGroup = new UntypedFormGroup({
    status: new UntypedFormControl(),
    feedbackTestlistung: new UntypedFormControl(),
    feedbackListung: new UntypedFormControl(),
  });

  result$: Observable<MyBusinessRelationResult>;

  totals: Map<BusinessInitiationStatus, number> = new Map();

  loaded = false;

  constructor(
    private readonly userService: VoilaUserService,
    private readonly business: BusinessInitiationService,
  ) {}

  ngOnInit() {
    const companyId = this.userService.currentUser().companyId;
    this.result$ = this.business.getStatus(companyId, this.startupId).pipe(tap(() => (this.loaded = true)));

    /* Backend -> Form */
    this.result$.subscribe((result) => {
      if (result.mine) {
        this.form.setValue({
          status: result.mine.status,
          feedbackTestlistung: result.mine.feedbackTestlistung,
          feedbackListung: result.mine.feedbackListung,
        });
        this.totals = new Map(Object.entries(result.total)) as Map<BusinessInitiationStatus, number>;
      } else {
        this.form.controls.status.setValue(BusinessInitiationStatus.keinKontakt);
      }
    });

    /* Form -> Backend */
    this.form.valueChanges.pipe(switchMap(() => this.business.setStatus(companyId, this.startupId, this.form.value))).subscribe((result) => {
      this.totals = new Map(Object.entries(result.total)) as Map<BusinessInitiationStatus, number>;
    });
  }

  get initiationStatuses(): BusinessInitiationStatus[] {
    return Object.values(BusinessInitiationStatus);
  }

  get feedbackValues(): FeedbackListung[] {
    return Object.values(FeedbackListung);
  }

  selected(bi: BusinessInitiationStatus): boolean {
    return leq(ordBIStatus)(bi, this.form.controls.status.value);
  }

  color(bi: BusinessInitiationStatus): string {
    if (bi === BusinessInitiationStatus.kontaktAufgenommen) {
      return 'orange';
    }
    if (bi === BusinessInitiationStatus.listungsgespraeche) {
      return 'orange';
    }
    if (bi === BusinessInitiationStatus.testlistung) {
      return 'green';
    }
    if (bi === BusinessInitiationStatus.listungGeplant) {
      return 'green';
    }
    if (bi === BusinessInitiationStatus.wiederAusgelistet) {
      return 'red';
    }
    return 'prune';
  }

  getCounter(status: BusinessInitiationStatus): number {
    return this.totals.get(status) || 0;
  }
}
